import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase';
import Form from './Form';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { FIELDS_PAGE_ERROR } from './validation/fields';
import { schema } from './validation/schema';

const PageError = ({ ...props }) => {
  const { mobile, motiveId, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  return (
    <FormBase
      issueForm
      mobile={mobile}
      buttonTitle="Enviar solicitud"
      title=""
      form={
        <Form
          state={state}
          onData={handleData}
          mobile={mobile}
          motiveId={motiveId}
        />
      }
      makeInitialState={makeInitialState}
      fields={FIELDS_PAGE_ERROR}
      formName="PageError"
      data={data}
      schema={schema}
      onState={onState}
      onValid={() => {}}
      motiveId={motiveId}
      typeId={typeId}
    />
  );
};

PageError.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  typeId: PropTypes.string,
};

export default PageError;
